// Chile regions and comunas data
export interface Comuna {
  id: string;
  name: string;
}

export interface Region {
  id: string;
  name: string;
  comunas: Comuna[];
}

// Helper to sort by name alphabetically
const sortByName = <T extends { name: string }>(items: T[]): T[] => {
  return [...items].sort((a, b) => a.name.localeCompare(b.name));
};

// Original data but with regions and comunas sorted alphabetically
const unsortedChileRegions: Region[] = [
  {
    id: "region-1",
    name: "Región de Arica y Parinacota",
    comunas: [
      { id: "comuna-1", name: "Arica" },
      { id: "comuna-2", name: "Camarones" },
      { id: "comuna-3", name: "Putre" },
      { id: "comuna-4", name: "General Lagos" },
    ],
  },
  {
    id: "region-2",
    name: "Región de Tarapacá",
    comunas: [
      { id: "comuna-5", name: "Iquique" },
      { id: "comuna-6", name: "Alto Hospicio" },
      { id: "comuna-7", name: "Pozo Almonte" },
      { id: "comuna-8", name: "Camiña" },
      { id: "comuna-9", name: "Colchane" },
      { id: "comuna-10", name: "Huara" },
      { id: "comuna-11", name: "Pica" },
    ],
  },
  {
    id: "region-3",
    name: "Región de Antofagasta",
    comunas: [
      { id: "comuna-12", name: "Antofagasta" },
      { id: "comuna-13", name: "Mejillones" },
      { id: "comuna-14", name: "Sierra Gorda" },
      { id: "comuna-15", name: "Taltal" },
      { id: "comuna-16", name: "Calama" },
      { id: "comuna-17", name: "Ollagüe" },
      { id: "comuna-18", name: "San Pedro de Atacama" },
      { id: "comuna-19", name: "Tocopilla" },
      { id: "comuna-20", name: "María Elena" },
    ],
  },
  {
    id: "region-4",
    name: "Región de Atacama",
    comunas: [
      { id: "comuna-21", name: "Copiapó" },
      { id: "comuna-22", name: "Caldera" },
      { id: "comuna-23", name: "Tierra Amarilla" },
      { id: "comuna-24", name: "Chañaral" },
      { id: "comuna-25", name: "Diego de Almagro" },
      { id: "comuna-26", name: "Vallenar" },
      { id: "comuna-27", name: "Alto del Carmen" },
      { id: "comuna-28", name: "Freirina" },
      { id: "comuna-29", name: "Huasco" },
    ],
  },
  {
    id: "region-5",
    name: "Región de Coquimbo",
    comunas: [
      { id: "comuna-30", name: "La Serena" },
      { id: "comuna-31", name: "Coquimbo" },
      { id: "comuna-32", name: "Andacollo" },
      { id: "comuna-33", name: "La Higuera" },
      { id: "comuna-34", name: "Paiguano" },
      { id: "comuna-35", name: "Vicuña" },
      { id: "comuna-36", name: "Illapel" },
      { id: "comuna-37", name: "Canela" },
      { id: "comuna-38", name: "Los Vilos" },
      { id: "comuna-39", name: "Salamanca" },
      { id: "comuna-40", name: "Ovalle" },
      { id: "comuna-41", name: "Combarbalá" },
      { id: "comuna-42", name: "Monte Patria" },
      { id: "comuna-43", name: "Punitaqui" },
      { id: "comuna-44", name: "Río Hurtado" },
    ],
  },
  {
    id: "region-6",
    name: "Región de Valparaíso",
    comunas: [
      { id: "comuna-45", name: "Valparaíso" },
      { id: "comuna-46", name: "Casablanca" },
      { id: "comuna-47", name: "Concón" },
      { id: "comuna-48", name: "Juan Fernández" },
      { id: "comuna-49", name: "Puchuncaví" },
      { id: "comuna-50", name: "Quintero" },
      { id: "comuna-51", name: "Viña del Mar" },
      { id: "comuna-52", name: "Isla de Pascua" },
      { id: "comuna-53", name: "Los Andes" },
      { id: "comuna-54", name: "Calle Larga" },
      { id: "comuna-55", name: "Rinconada" },
      { id: "comuna-56", name: "San Esteban" },
      { id: "comuna-57", name: "La Ligua" },
      { id: "comuna-58", name: "Cabildo" },
      { id: "comuna-59", name: "Papudo" },
      { id: "comuna-60", name: "Petorca" },
      { id: "comuna-61", name: "Zapallar" },
      { id: "comuna-62", name: "Quillota" },
      { id: "comuna-63", name: "Calera" },
      { id: "comuna-64", name: "Hijuelas" },
      { id: "comuna-65", name: "La Cruz" },
      { id: "comuna-66", name: "Nogales" },
      { id: "comuna-67", name: "San Antonio" },
      { id: "comuna-68", name: "Algarrobo" },
      { id: "comuna-69", name: "Cartagena" },
      { id: "comuna-70", name: "El Quisco" },
      { id: "comuna-71", name: "El Tabo" },
      { id: "comuna-72", name: "Santo Domingo" },
      { id: "comuna-73", name: "San Felipe" },
      { id: "comuna-74", name: "Catemu" },
      { id: "comuna-75", name: "Llaillay" },
      { id: "comuna-76", name: "Panquehue" },
      { id: "comuna-77", name: "Putaendo" },
      { id: "comuna-78", name: "Santa María" },
      { id: "comuna-79", name: "Quilpué" },
      { id: "comuna-80", name: "Limache" },
      { id: "comuna-81", name: "Olmué" },
      { id: "comuna-82", name: "Villa Alemana" },
    ],
  },
  {
    id: "region-7",
    name: "Región Metropolitana de Santiago",
    comunas: [
      { id: "comuna-83", name: "Santiago" },
      { id: "comuna-84", name: "Cerrillos" },
      { id: "comuna-85", name: "Cerro Navia" },
      { id: "comuna-86", name: "Conchalí" },
      { id: "comuna-87", name: "El Bosque" },
      { id: "comuna-88", name: "Estación Central" },
      { id: "comuna-89", name: "Huechuraba" },
      { id: "comuna-90", name: "Independencia" },
      { id: "comuna-91", name: "La Cisterna" },
      { id: "comuna-92", name: "La Florida" },
      { id: "comuna-93", name: "La Granja" },
      { id: "comuna-94", name: "La Pintana" },
      { id: "comuna-95", name: "La Reina" },
      { id: "comuna-96", name: "Las Condes" },
      { id: "comuna-97", name: "Lo Barnechea" },
      { id: "comuna-98", name: "Lo Espejo" },
      { id: "comuna-99", name: "Lo Prado" },
      { id: "comuna-100", name: "Macul" },
      { id: "comuna-101", name: "Maipú" },
      { id: "comuna-102", name: "Ñuñoa" },
      { id: "comuna-103", name: "Pedro Aguirre Cerda" },
      { id: "comuna-104", name: "Peñalolén" },
      { id: "comuna-105", name: "Providencia" },
      { id: "comuna-106", name: "Pudahuel" },
      { id: "comuna-107", name: "Quilicura" },
      { id: "comuna-108", name: "Quinta Normal" },
      { id: "comuna-109", name: "Recoleta" },
      { id: "comuna-110", name: "Renca" },
      { id: "comuna-111", name: "San Joaquín" },
      { id: "comuna-112", name: "San Miguel" },
      { id: "comuna-113", name: "San Ramón" },
      { id: "comuna-114", name: "Vitacura" },
      { id: "comuna-115", name: "Puente Alto" },
      { id: "comuna-116", name: "Pirque" },
      { id: "comuna-117", name: "San José de Maipo" },
      { id: "comuna-118", name: "Colina" },
      { id: "comuna-119", name: "Lampa" },
      { id: "comuna-120", name: "Tiltil" },
      { id: "comuna-121", name: "San Bernardo" },
      { id: "comuna-122", name: "Buin" },
      { id: "comuna-123", name: "Calera de Tango" },
      { id: "comuna-124", name: "Paine" },
      { id: "comuna-125", name: "Melipilla" },
      { id: "comuna-126", name: "Alhué" },
      { id: "comuna-127", name: "Curacaví" },
      { id: "comuna-128", name: "María Pinto" },
      { id: "comuna-129", name: "San Pedro" },
      { id: "comuna-130", name: "Talagante" },
      { id: "comuna-131", name: "El Monte" },
      { id: "comuna-132", name: "Isla de Maipo" },
      { id: "comuna-133", name: "Padre Hurtado" },
      { id: "comuna-134", name: "Peñaflor" },
    ],
  },
  {
    id: "region-8",
    name: "Región del Libertador General Bernardo O'Higgins",
    comunas: [
      { id: "comuna-135", name: "Rancagua" },
      { id: "comuna-136", name: "Codegua" },
      { id: "comuna-137", name: "Coinco" },
      { id: "comuna-138", name: "Coltauco" },
      { id: "comuna-139", name: "Doñihue" },
      { id: "comuna-140", name: "Graneros" },
      { id: "comuna-141", name: "Las Cabras" },
      { id: "comuna-142", name: "Machalí" },
      { id: "comuna-143", name: "Malloa" },
      { id: "comuna-144", name: "Mostazal" },
      { id: "comuna-145", name: "Olivar" },
      { id: "comuna-146", name: "Peumo" },
      { id: "comuna-147", name: "Pichidegua" },
      { id: "comuna-148", name: "Quinta de Tilcoco" },
      { id: "comuna-149", name: "Rengo" },
      { id: "comuna-150", name: "Requínoa" },
      { id: "comuna-151", name: "San Vicente" },
      { id: "comuna-152", name: "Pichilemu" },
      { id: "comuna-153", name: "La Estrella" },
      { id: "comuna-154", name: "Litueche" },
      { id: "comuna-155", name: "Marchihue" },
      { id: "comuna-156", name: "Navidad" },
      { id: "comuna-157", name: "Paredones" },
      { id: "comuna-158", name: "San Fernando" },
      { id: "comuna-159", name: "Chépica" },
      { id: "comuna-160", name: "Chimbarongo" },
      { id: "comuna-161", name: "Lolol" },
      { id: "comuna-162", name: "Nancagua" },
      { id: "comuna-163", name: "Palmilla" },
      { id: "comuna-164", name: "Peralillo" },
      { id: "comuna-165", name: "Placilla" },
      { id: "comuna-166", name: "Pumanque" },
      { id: "comuna-167", name: "Santa Cruz" },
    ],
  },
  {
    id: "region-9",
    name: "Región del Maule",
    comunas: [
      { id: "comuna-168", name: "Talca" },
      { id: "comuna-169", name: "Constitución" },
      { id: "comuna-170", name: "Curepto" },
      { id: "comuna-171", name: "Empedrado" },
      { id: "comuna-172", name: "Maule" },
      { id: "comuna-173", name: "Pelarco" },
      { id: "comuna-174", name: "Pencahue" },
      { id: "comuna-175", name: "Río Claro" },
      { id: "comuna-176", name: "San Clemente" },
      { id: "comuna-177", name: "San Rafael" },
      { id: "comuna-178", name: "Cauquenes" },
      { id: "comuna-179", name: "Chanco" },
      { id: "comuna-180", name: "Pelluhue" },
      { id: "comuna-181", name: "Curicó" },
      { id: "comuna-182", name: "Hualañé" },
      { id: "comuna-183", name: "Licantén" },
      { id: "comuna-184", name: "Molina" },
      { id: "comuna-185", name: "Rauco" },
      { id: "comuna-186", name: "Romeral" },
      { id: "comuna-187", name: "Sagrada Familia" },
      { id: "comuna-188", name: "Teno" },
      { id: "comuna-189", name: "Vichuquén" },
      { id: "comuna-190", name: "Linares" },
      { id: "comuna-191", name: "Colbún" },
      { id: "comuna-192", name: "Longaví" },
      { id: "comuna-193", name: "Parral" },
      { id: "comuna-194", name: "Retiro" },
      { id: "comuna-195", name: "San Javier" },
      { id: "comuna-196", name: "Villa Alegre" },
      { id: "comuna-197", name: "Yerbas Buenas" },
    ],
  },
  {
    id: "region-10",
    name: "Región de Ñuble",
    comunas: [
      { id: "comuna-198", name: "Chillán" },
      { id: "comuna-199", name: "Bulnes" },
      { id: "comuna-200", name: "Chillán Viejo" },
      { id: "comuna-201", name: "El Carmen" },
      { id: "comuna-202", name: "Pemuco" },
      { id: "comuna-203", name: "Pinto" },
      { id: "comuna-204", name: "Quillón" },
      { id: "comuna-205", name: "San Ignacio" },
      { id: "comuna-206", name: "Yungay" },
      { id: "comuna-207", name: "Quirihue" },
      { id: "comuna-208", name: "Cobquecura" },
      { id: "comuna-209", name: "Coelemu" },
      { id: "comuna-210", name: "Ninhue" },
      { id: "comuna-211", name: "Portezuelo" },
      { id: "comuna-212", name: "Ránquil" },
      { id: "comuna-213", name: "Treguaco" },
      { id: "comuna-214", name: "San Carlos" },
      { id: "comuna-215", name: "Coihueco" },
      { id: "comuna-216", name: "Ñiquén" },
      { id: "comuna-217", name: "San Fabián" },
      { id: "comuna-218", name: "San Nicolás" },
    ],
  },
  {
    id: "region-11",
    name: "Región del Biobío",
    comunas: [
      { id: "comuna-219", name: "Concepción" },
      { id: "comuna-220", name: "Coronel" },
      { id: "comuna-221", name: "Chiguayante" },
      { id: "comuna-222", name: "Florida" },
      { id: "comuna-223", name: "Hualqui" },
      { id: "comuna-224", name: "Lota" },
      { id: "comuna-225", name: "Penco" },
      { id: "comuna-226", name: "San Pedro de la Paz" },
      { id: "comuna-227", name: "Santa Juana" },
      { id: "comuna-228", name: "Talcahuano" },
      { id: "comuna-229", name: "Tomé" },
      { id: "comuna-230", name: "Hualpén" },
      { id: "comuna-231", name: "Lebu" },
      { id: "comuna-232", name: "Arauco" },
      { id: "comuna-233", name: "Cañete" },
      { id: "comuna-234", name: "Contulmo" },
      { id: "comuna-235", name: "Curanilahue" },
      { id: "comuna-236", name: "Los Álamos" },
      { id: "comuna-237", name: "Tirúa" },
      { id: "comuna-238", name: "Los Ángeles" },
      { id: "comuna-239", name: "Antuco" },
      { id: "comuna-240", name: "Cabrero" },
      { id: "comuna-241", name: "Laja" },
      { id: "comuna-242", name: "Mulchén" },
      { id: "comuna-243", name: "Nacimiento" },
      { id: "comuna-244", name: "Negrete" },
      { id: "comuna-245", name: "Quilaco" },
      { id: "comuna-246", name: "Quilleco" },
      { id: "comuna-247", name: "San Rosendo" },
      { id: "comuna-248", name: "Santa Bárbara" },
      { id: "comuna-249", name: "Tucapel" },
      { id: "comuna-250", name: "Yumbel" },
      { id: "comuna-251", name: "Alto Biobío" },
    ],
  },
  {
    id: "region-12",
    name: "Región de La Araucanía",
    comunas: [
      { id: "comuna-252", name: "Temuco" },
      { id: "comuna-253", name: "Carahue" },
      { id: "comuna-254", name: "Cunco" },
      { id: "comuna-255", name: "Curarrehue" },
      { id: "comuna-256", name: "Freire" },
      { id: "comuna-257", name: "Galvarino" },
      { id: "comuna-258", name: "Gorbea" },
      { id: "comuna-259", name: "Lautaro" },
      { id: "comuna-260", name: "Loncoche" },
      { id: "comuna-261", name: "Melipeuco" },
      { id: "comuna-262", name: "Nueva Imperial" },
      { id: "comuna-263", name: "Padre Las Casas" },
      { id: "comuna-264", name: "Perquenco" },
      { id: "comuna-265", name: "Pitrufquén" },
      { id: "comuna-266", name: "Pucón" },
      { id: "comuna-267", name: "Saavedra" },
      { id: "comuna-268", name: "Teodoro Schmidt" },
      { id: "comuna-269", name: "Toltén" },
      { id: "comuna-270", name: "Vilcún" },
      { id: "comuna-271", name: "Villarrica" },
      { id: "comuna-272", name: "Cholchol" },
      { id: "comuna-273", name: "Angol" },
      { id: "comuna-274", name: "Collipulli" },
      { id: "comuna-275", name: "Curacautín" },
      { id: "comuna-276", name: "Ercilla" },
      { id: "comuna-277", name: "Lonquimay" },
      { id: "comuna-278", name: "Los Sauces" },
      { id: "comuna-279", name: "Lumaco" },
      { id: "comuna-280", name: "Purén" },
      { id: "comuna-281", name: "Renaico" },
      { id: "comuna-282", name: "Traiguén" },
      { id: "comuna-283", name: "Victoria" },
    ],
  },
  {
    id: "region-13",
    name: "Región de Los Ríos",
    comunas: [
      { id: "comuna-284", name: "Valdivia" },
      { id: "comuna-285", name: "Corral" },
      { id: "comuna-286", name: "Lanco" },
      { id: "comuna-287", name: "Los Lagos" },
      { id: "comuna-288", name: "Máfil" },
      { id: "comuna-289", name: "Mariquina" },
      { id: "comuna-290", name: "Paillaco" },
      { id: "comuna-291", name: "Panguipulli" },
      { id: "comuna-292", name: "La Unión" },
      { id: "comuna-293", name: "Futrono" },
      { id: "comuna-294", name: "Lago Ranco" },
      { id: "comuna-295", name: "Río Bueno" },
    ],
  },
  {
    id: "region-14",
    name: "Región de Los Lagos",
    comunas: [
      { id: "comuna-296", name: "Puerto Montt" },
      { id: "comuna-297", name: "Calbuco" },
      { id: "comuna-298", name: "Cochamó" },
      { id: "comuna-299", name: "Fresia" },
      { id: "comuna-300", name: "Frutillar" },
      { id: "comuna-301", name: "Los Muermos" },
      { id: "comuna-302", name: "Llanquihue" },
      { id: "comuna-303", name: "Maullín" },
      { id: "comuna-304", name: "Puerto Varas" },
      { id: "comuna-305", name: "Castro" },
      { id: "comuna-306", name: "Ancud" },
      { id: "comuna-307", name: "Chonchi" },
      { id: "comuna-308", name: "Curaco de Vélez" },
      { id: "comuna-309", name: "Dalcahue" },
      { id: "comuna-310", name: "Puqueldón" },
      { id: "comuna-311", name: "Queilén" },
      { id: "comuna-312", name: "Quellón" },
      { id: "comuna-313", name: "Quemchi" },
      { id: "comuna-314", name: "Quinchao" },
      { id: "comuna-315", name: "Osorno" },
      { id: "comuna-316", name: "Puerto Octay" },
      { id: "comuna-317", name: "Purranque" },
      { id: "comuna-318", name: "Puyehue" },
      { id: "comuna-319", name: "Río Negro" },
      { id: "comuna-320", name: "San Juan de la Costa" },
      { id: "comuna-321", name: "San Pablo" },
      { id: "comuna-322", name: "Chaitén" },
      { id: "comuna-323", name: "Futaleufú" },
      { id: "comuna-324", name: "Hualaihué" },
      { id: "comuna-325", name: "Palena" },
    ],
  },
  {
    id: "region-15",
    name: "Región de Aysén del General Carlos Ibáñez del Campo",
    comunas: [
      { id: "comuna-326", name: "Coihaique" },
      { id: "comuna-327", name: "Lago Verde" },
      { id: "comuna-328", name: "Aysén" },
      { id: "comuna-329", name: "Cisnes" },
      { id: "comuna-330", name: "Guaitecas" },
      { id: "comuna-331", name: "Cochrane" },
      { id: "comuna-332", name: "O'Higgins" },
      { id: "comuna-333", name: "Tortel" },
      { id: "comuna-334", name: "Chile Chico" },
      { id: "comuna-335", name: "Río Ibáñez" },
    ],
  },
  {
    id: "region-16",
    name: "Región de Magallanes y de la Antártica Chilena",
    comunas: [
      { id: "comuna-336", name: "Punta Arenas" },
      { id: "comuna-337", name: "Laguna Blanca" },
      { id: "comuna-338", name: "Río Verde" },
      { id: "comuna-339", name: "San Gregorio" },
      { id: "comuna-340", name: "Cabo de Hornos" },
      { id: "comuna-341", name: "Antártica" },
      { id: "comuna-342", name: "Porvenir" },
      { id: "comuna-343", name: "Primavera" },
      { id: "comuna-344", name: "Timaukel" },
      { id: "comuna-345", name: "Natales" },
      { id: "comuna-346", name: "Torres del Paine" },
    ],
  },
];

// Export sorted regions and comunas
export const chileRegions: Region[] = sortByName(unsortedChileRegions).map(
  (region) => ({
    ...region,
    comunas: sortByName(region.comunas),
  })
);

// Helper to find a region by ID
export const findRegionById = (regionId: string): Region | undefined => {
  return chileRegions.find((region) => region.id === regionId);
};

// Helper to find a comuna by ID
export const findComunaById = (comunaId: string): Comuna | undefined => {
  for (const region of chileRegions) {
    const comuna = region.comunas.find((comuna) => comuna.id === comunaId);
    if (comuna) return comuna;
  }
  return undefined;
};

// Helper to get comunas by region ID
export const getComunasByRegionId = (regionId: string): Comuna[] => {
  const region = findRegionById(regionId);
  return region ? region.comunas : [];
};
